import { initiatives } from "../../data/building";
import Container from "../ui/Container";
import SectionHeader from "../ui/SectionHeader";
import StatusBadge from "../ui/StatusBadge";

function NowBuildingSection() {
  return (
    <section className="py-16 sm:py-20">
      <Container>
        <SectionHeader
          title="Now Building"
          subtitle="Upcoming initiatives that extend Technie beyond a single product."
        />
        <div className="mt-8 divide-y divide-border/80 rounded-2xl border border-border/80">
          {initiatives.map((initiative) => (
            <div
              key={initiative.title}
              className="flex items-center justify-between gap-4 p-4 transition-all duration-200 ease-in-out hover:bg-surface/25 sm:px-5"
            >
              <h3 className="text-sm font-medium text-primary">{initiative.title}</h3>
              <StatusBadge status={initiative.status} />
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}

export default NowBuildingSection;
